import { useHistory, useLocation } from 'react-router-dom';
import Pagination from '@material-ui/lab/Pagination';
import { useSaleTable } from './SaleTable';

export default function SaleTablePagination() {
  const history = useHistory();
  const location = useLocation();
  const {
    gotoPage,
    pageCount,
    state: { pageIndex },
  } = useSaleTable();

  return (
    <Pagination
      count={Math.min(Math.ceil((pageIndex + 2) / 100) * 100, pageCount)}
      page={pageIndex + 1}
      onChange={(_event, page) => {
        gotoPage(page - 1);
        history.push({
          ...location,
          state: { ...location.state, pageIndex: page - 1 },
        });
      }}
    />
  );
}
